import { LucideIcon } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface ActionCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ActionCard = ({ icon: Icon, title, description, onClick, disabled }: ActionCardProps) => {
  return (
    <Card
      onClick={disabled ? undefined : onClick}
      className={`group transition-all ${
        disabled
          ? 'opacity-50 cursor-not-allowed'
          : 'cursor-pointer hover:shadow-md hover:border-primary/50 hover:scale-105'
      }`}
    >
      <CardHeader className='pb-3'>
        <div className='flex items-center gap-3'>
          <div className='rounded-lg bg-primary/10 p-2'>
            <Icon className='h-4 w-4 text-primary' />
          </div>
          <CardTitle className='text-base font-semibold'>{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <CardDescription className='text-sm'>{description}</CardDescription>
      </CardContent>
    </Card>
  );
};

export default ActionCard;
